import { render, staticRenderFns } from "./preFacturas.vue?vue&type=template&id=0dbbc416&scoped=true"
import script from "./preFacturas.vue?vue&type=script&lang=js"
export * from "./preFacturas.vue?vue&type=script&lang=js"
import style0 from "./preFacturas.vue?vue&type=style&index=0&id=0dbbc416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbbc416",
  null
  
)

export default component.exports